import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKeyParam } from '../../../query/types';

export const participantsKeys = (scopeId: QueryKeyParam) => {
  const key = ['store', scopeId, 'consumer'] as const;

  return createQueryKey({
    all: [...key, 'participants'] as const,
    infinite: [...key, 'participants', 'infinite'] as const,
  });
};
